import type { OpenSearchProductRow } from "../types/products";
import {
    readBoolean,
    readNumber,
    readString,
    readStringArray,
} from "../utils/opensearch-source-readers";

function mapHitSourceToOpenSearchProductRow(
    source: Record<string, unknown>,
): OpenSearchProductRow {
    const id = readString(source, "id", "product_id", "sku");
    const name = readString(
        source,
        "name",
        "menuTitle",
        "title",
        "productName",
    );
    const menuTitle = readString(source, "menuTitle", "title", "name");
    const brand = readString(source, "brand_name", "brand", "brandName");
    const category = readString(source, "category", "category_name", "type");
    const classification = readString(source, "classification");
    const createdDate = readString(source, "createdDate");
    const customCustomerType = readString(source, "customCustomerType");
    const customSize = readStringArray(source, "customSize");
    const effects = readStringArray(source, "effects");
    const flavors = readStringArray(source, "flavors");
    const generals = readStringArray(source, "generals");
    const ingredients = readStringArray(source, "ingredients");
    const internalTags = readStringArray(source, "internalTags");
    const isActive = readBoolean(
        source,
        "isActive",
        "in_stock",
        "inStock",
        "available",
    );
    const isHideFromMenu = readBoolean(source, "isHideFromMenu");
    const oldSlug = readString(source, "oldSlug");
    const slug = readString(source, "slug");
    const status = readString(source, "status");
    const subtype = readString(source, "subtype");
    const unitOfMeasurement = readString(source, "unitOfMeasurement");
    const availableUnits = readNumber(
        source,
        "availableUnits",
        "qty",
        "quantity",
        "inventory_quantity",
    );

    const productDataRaw = source.productData;
    const productData =
        productDataRaw &&
        typeof productDataRaw === "object" &&
        !Array.isArray(productDataRaw)
            ? (productDataRaw as Record<string, unknown>)
            : {};

    const externalId = readString(productData, "externalId") || id;
    const lastUpdateDate = readString(productData, "lastUpdateDate");
    const size = readString(productData, "size");
    const isCannabis = readBoolean(productData, "isCannabis");
    const assets = readStringArray(productData, "images");

    const key = id || name || JSON.stringify(source).slice(0, 40);

    return {
        key,
        id: id || key,
        name,
        menuTitle,
        brand,
        category,
        classification,
        createdDate,
        customCustomerType,
        customSize,
        effects,
        flavors,
        generals,
        ingredients,
        internalTags,
        isActive,
        isHideFromMenu,
        oldSlug,
        externalId,
        assets,
        isCannabis,
        lastUpdateDate,
        size,
        slug,
        status,
        subtype,
        unitOfMeasurement,
        availableUnits,
    };
}

export { mapHitSourceToOpenSearchProductRow };
